import React from "react";

export default function StandaloneSensorCard({ label, present, onToggle }) {
  return (
    <div className="standalone-sensor-card">
      <input
        type="checkbox"
        checked={present}
        onChange={(e) => onToggle(e.target.checked)}
        aria-label={`${label} present`}
      />
      <span className="standalone-sensor-label">{label}</span>
      <span className="standalone-sensor-status">{present ? "Installed" : "Not installed"}</span>
    </div>
  );
}
